import { ActionWrapper, ContentWrapper } from './style';
import { Analyzing, Expired } from './components/Modal';
import React, { useEffect, useState } from 'react';

import { ActionButton } from '@icarros/ids-react';
import { AdEmptyState } from './AdEmptyState';
import { Card } from './components/Card';
import { Header } from './Header';
import { Loading } from '../../components/Loading';
import { STATUS } from '../../enum/listing-status';
import { ShimmerWrapper } from '../../components/ShimmerWrapper/ShimmerWrapper';
import { useFilter } from '../../store/hooks/useFilter';
import { useListing } from '../../hooks/useListing';
import { useListingFilterContext } from '../../store/contexts/listingFilter';

export function Content(): JSX.Element {
  const { loading, isRefetching } = useListing();
  const { selectedOption } = useListingFilterContext();
  const { listingFiltered } = useFilter();
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setModalOpen(false);
  }, [listingFiltered]);

  return (
    <>
      {isRefetching && <Loading />}
      <Header hasAds={!!listingFiltered?.length} isShimmering={loading} />
      {selectedOption === STATUS.analyzing && (
        <>
          <ActionWrapper>
            <ActionButton
              iconName="itaufonts_informacao"
              text="por que o anúncio está em análise?"
              contrast="default"
              variant="secondary"
              weight="medium"
              onClick={() => setModalOpen(true)}
            />
          </ActionWrapper>
          <Analyzing modalOpen={modalOpen} setModalOpen={setModalOpen} />
        </>
      )}
      {selectedOption === STATUS.expired && (
        <>
          <ActionWrapper>
            <ActionButton
              iconName="itaufonts_informacao"
              text="o que são os anúncios expirados?"
              contrast="default"
              variant="secondary"
              weight="medium"
              onClick={() => setModalOpen(true)}
            />
          </ActionWrapper>
          <Expired modalOpen={modalOpen} setModalOpen={setModalOpen} />
        </>
      )}
      {listingFiltered?.length || loading ? (
        <ContentWrapper>
          {loading ? (
            <ShimmerWrapper type="card" />
          ) : (
            listingFiltered?.map(card => <Card key={card.id} card={card} />)
          )}
        </ContentWrapper>
      ) : (
        <AdEmptyState />
      )}
    </>
  );
}
